import userSlice from '~/redux/slices/userSlice';

export default function useUserProfile(requiredProfileType) {
  const userQueryState = userSlice.endpoints.getUser.useQueryState();
  const userProfiles = userQueryState.data?.userProfiles || [];
  return userProfiles.find((profile) => profile.type === requiredProfileType)?.data;
}
